import axios from "../core/axios";

export type ChannelType = 'WHATSAPP' | 'SMS';

export default class SenderRegistrationsService {
  async getRequirements(channelType: ChannelType) {
    const res = await axios.get(`/sender-registrations/requirements`, { params: { channelType } });
    return res.data;
  }

  async initRegistration(payload: { channelType: ChannelType; documents: Record<string, any>; provider?: string; senderId?: string }) {
    const res = await axios.post(`/sender-registrations/init`, payload);
    return res.data;
  }

  async list() {
    const res = await axios.get(`/sender-registrations`);
    return res.data;
  }

  async getOne(id: string) {
    const res = await axios.get(`/sender-registrations/${id}`);
    return res.data;
  }

  async updateStatus(id: string, status: 'PENDING' | 'UNDER_REVIEW' | 'APPROVED' | 'REJECTED' | 'ACTIVE') {
    const res = await axios.patch(`/sender-registrations/${id}/status`, { status });
    return res.data;
  }

  // WhatsApp specific
  async waListNumbers(wabaId: string, accessToken: string) {
    const res = await axios.post(`/sender-registrations/whatsapp/list-numbers`, { wabaId, accessToken });
    return res.data;
  }

  async waRequestCode(accessToken: string, phoneNumberId: string, method: 'SMS' | 'VOICE' = 'SMS', language: string = 'en_US') {
    const res = await axios.post(`/sender-registrations/whatsapp/request-code`, { accessToken, phoneNumberId, method, language });
    return res.data;
  }

  async waVerifyCode(wabaId: string, accessToken: string, phoneNumberId: string, displayPhoneNumber?: string) {
    const res = await axios.post(`/sender-registrations/whatsapp/verify-code`, { wabaId, accessToken, phoneNumberId, displayPhoneNumber });
    return res.data;
  }
} 